export const formatDate = (timestamp) => {
      if (!timestamp) return '-';

    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);
    
    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(diffInSeconds / 3600);
    const days = Math.floor(diffInSeconds / (3600 * 24));
    const months = Math.floor(diffInSeconds / (3600 * 24 * 30)); // Approximation for months
    const years = Math.floor(diffInSeconds / (3600 * 24 * 365)); // Approximation for years

    if (minutes < 1) {
      return `${diffInSeconds} sec ago`;
    } else if (minutes < 60) {
      return `${minutes} min ago`;
    } else if (hours < 24) {
      return `${hours} hr ago`;
    } else if (days < 30) {
      return `${days} day ago`;
    } else if (months < 12) {
      return `${months} month ago`;
    } else {
      return `${years} year ago`;
    }
  };


  export const formatDateOnly = (timestamp)=> {
    if (!timestamp) return '-';

    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  


 export const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
    return `${year}${month}${day}`;
  };
  
  export const computeDateRange = (filter) => {
    const now = new Date();
    const toDate = Math.floor(now.getTime()); // Unix timestamp in seconds
    let fromDate = toDate;
  
    switch (filter) {
      case "last30days":
        fromDate = Math.floor(new Date(now.setDate(now.getDate() - 30)).getTime() );
        break;
      case "last60days":
        fromDate = Math.floor(new Date(now.setDate(now.getDate() - 60)).getTime() );
        break;
      case "last90days":
        fromDate = Math.floor(new Date(now.setDate(now.getDate() - 90)).getTime() );
        break;
      case "last6months":
        fromDate = Math.floor(new Date(now.setMonth(now.getMonth() - 6)).getTime() );
        break;
      case "last1year":
        fromDate = Math.floor(new Date(now.setFullYear(now.getFullYear() - 1)).getTime() );
        break;
      default:
        break;
    }
  
    return { fromDate, toDate };
  };


export const getDefaultDates = () => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setDate(lastMonth.getDate() - 30);

    return {
      start: lastMonth,
      end: today,
    };
  };
  export const getTimestamp = (date) => {
    if (!date) return null;
    if (typeof date === 'string') {
      return new Date(date).getTime();
    }
    if (date instanceof Date) {
      return date.getTime();
    }
    return date;
  };

  export const timeStamptoDate = (timestamp) => {
    if (!timestamp) return null;
    return new Date(timestamp).toISOString().split('T')[0];
  }

  export const getStartOfDay = (date) => {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0); // HH:mm:ss.SSS => 00:00:00.000
  return startOfDay;
};

export const getEndOfDay = (date) => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
};
export const getStartOfDayTimestamp = (date) => {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  return startOfDay.getTime(); // returns timestamp
};

export const getEndOfDayTimestamp = (date) => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay.getTime(); // returns timestamp
};
